class DocumentTestResults {

    constructor() {

        this._modalTestResultsTemplate = null;
        this._baseScreenTemplate = null;
        this._lastTest = null;

        this._loadTemplates();

    }

    _loadTemplates() {

        this._modalTestResultsTemplate = Handlebars.compile($("#testDocResultsModal").html());
        this._baseScreenTemplate = Handlebars.compile($("#baseScreen").html());

    }

    updateTestDocument(testResults) {
        try {
            function _maxCriteria(test) {
                return test.end_date;
            }

            this._lastTest = _.maxBy(testResults.games, _maxCriteria);

            documentObj.own_test.games = testResults.games;
            documentObj.own_test.tries = testResults.tries;

            // Si es test dejar de registrar tiempo al terminar el test
            documentationScreenController.documentationProgress.stopRead(testResults.document_id);

            let document = Object.assign(
                {
                    own_test: {
                        games: [],
                        tries: 0
                    }
                },
                documentationScreenController.getDocument(testResults.document_id)
            );

            if (document && document.own_test) {
                document.own_test.games = testResults.games;
                document.own_test.tries = testResults.tries;

                const isModuleApp = window.reactZustandBridge && world && world?.mode === 'newLayout';

                if (isModuleApp) {
                    // update module-app content
                    window.reactZustandBridge.updateContentByContentId(testResults.document_id, document)

                    // update legacy document
                    documentationScreenController.documentsAsResources[testResults.document_id] = document;
                }
            }
        } catch (e) {
            console.error('updateTestDocument: ', e);
        }
    }

    // IZE-9629 (FR-011, superado por FR-023): la completitud del Test ya la decide y persiste el
    // backend dentro de la propia llamada a `.../register` (`sendCompleteDocumentGame`, antes
    // `.../complete`). No existe ni existió ningún paso de verificación previa (`completion-test-check`)
    // real en este flujo. El frontend no dispara ninguna llamada de completitud adicional (evita
    // reevaluar la regla en cliente, con riesgo de divergencia respecto al backend) — esta condición
    // se conserva solo para reflejar el estado en la UI local.
    setDocumentCompleted(testResults) {

        try {
            const document = documentationScreenController.getDocument(testResults.document_id);

            if (parseInt(document.own_test.tries) === document.own_test.maximum_tries || this._lastTest.qualification >= documentObj.own_test.minimum_qualification) {
                documentationScreenController.documentationProgress.markCompletedLocally(document.id);

                // El test de path (isPathTestContent) no pasa por onCompletedClass (solo isPathClassContent),
                // así que hay que refrescar aquí la completitud del path (listado + modal de path completado).
                if (documentObj.isPathTestContent || documentObj.is_path_content) {
                    const documentationPath = documentationScreenController.documentationPath;
                    const pathData = documentationPath.getPathData();

                    documentationPath.checkAndRefreshPathCompletion(pathData.id, documentationPath.getPathDocumentId());
                }
            }
        } catch (e) {
            // No debe impedir que apicalls continúe con goToMainApp().
            console.error('setDocumentCompleted: ', e);
        }

    }

    showResultsModal() {

        const $modalContainer = $("#modalContainer");
        const context = {
            stateColorClass: this._lastTest.qualification >= documentObj.own_test.minimum_qualification ? "colorOK-text" : "colorERROR-text",
            state: this._lastTest.qualification >= documentObj.own_test.minimum_qualification ? Translator.trans("TR_SUPERADO") : Translator.trans("TR_NO_SUPERADO"),
            qualification: this._lastTest.qualification,
            totalQuestions: this._lastTest.total_questions,
            correctAnswers: this._lastTest.answered_correctly,
            startTime: this._lastTest.start_date,
            endTime: this._lastTest.end_date
        }

        $modalContainer.html(this._modalTestResultsTemplate(context));
        $modalContainer.modal("show");

    }

    showAssessmentResultsPopUp() {

        documentationScreenController.documentationPath.openAssessmentResultsPopUp(documentObj);

        const $closePopUpButton = $("div.action-button.path-assessment-confirm-button");
        $closePopUpButton.one("click.goToMainApp", this.goToMainApp.bind(this));

    }

    hideResultsModal() {

        const $modalContainer = $("#modalContainer");
        $modalContainer.modal('hide').empty();

    }

    goToMainApp() {

        function _onTransitionComplete() {

            if (documentObj.path_document_id) {

                // Test de un path abierto desde el path: el cierre de la pantalla del test ya vuelve a dibujar el
                // path (closeDocumentDetails con returnToPath). Redibujarlo aquí lo duplicaba y dejaba capas del test.
                const closeTestButton = window.document.querySelector('#legacyStack #documentation-header-close-btn');
                const isModuleApp = window.reactZustandBridge && world && world?.mode === 'newLayout';

                if (isModuleApp && closeTestButton && documentationScreenController.documentationPath.getReturnToPath()) {
                    // Reconstruir la pantalla principal retira la pantalla del test (#questionContainer), que vive en ella.
                    resetMainScreen();
                    closeTestButton.click();
                    documentationScreenController.openDocumentation(documentationScreenController.documentation, null, null, false);
                    return;
                }

                if (!documentObj.own_test.is_path_assessment_test) {
                    documentationScreenController.documentationPath.setOpenTestOnLoad(true);
                }

                document = documentationScreenController.getDocument(documentObj.path_document_id);
                parentFolder = documentationScreenController.getParentFolder(documentObj.path_document_id, documentationScreenController.documentation);
                documentationScreenController.documentationPath.getPath(document.path_id, onGetPathSuccess);

            } else {

                document = documentationScreenController.getDocument(documentObj.id);
                parentFolder = documentationScreenController.getParentFolder(documentObj.id, documentationScreenController.documentation);

                drawDocumentDetails();
            }

        }

        function onGetPathSuccess(pathData) {

            document.pathData = pathData;
            drawDocumentDetails();

        }

        function resetMainScreen() {
            $mainContainer.html(that._baseScreenTemplate(world));

            if (world.is_lms && storage.getItem("lms_path_id")) {
                $("#appHeader").removeClass("world_color_1_bg");
            }

            baseController.draw(world.theme);
        }

        function drawDocumentDetails() {
            const isModuleApp = window.reactZustandBridge && world && world?.mode === 'newLayout';

            // Force this flow when is module app
            if (isModuleApp || baseController?.currentActiveTab?.id === new Tabs().LINKS_TAB) {
                resetMainScreen();

                // Force close test screen (if is module app)
                if (isModuleApp) {
                    const closeTestButton = window.document.querySelector('#legacyStack #documentation-header-close-btn');

                    if (closeTestButton) {
                        closeTestButton.click();
                    }

                    // Si el cierre no la retiró, la capa del test quedaba bajo el path y reaparecía al salir de él.
                    $("#legacyStack section").has(".doc-details-TEST").remove();
                }

                documentationScreenController.openDocumentation(documentationScreenController.documentation, null, null, false);
                documentationScreenController.drawDocumentDetails(null, document, null, parentFolder);
            } else {
                baseController.selectedTabAction(baseController?.currentActiveTab?.world_tab_id);
            }
        }

        const $mainContainer = $("#mainContainer");
        const that = this;
        let document = {};
        let parentFolder = null;

        setTimeout(_onTransitionComplete, popUpController.getAnimationSpeed());

    }

}